import React from 'react';
import SADatePicker from "../../common/input/SADatePicker";
import {injectIntl} from "react-intl";

class FromToDates extends React.Component {

  renderTo = (to, onToChange, disabledTo, error, formatMessage) => (
      <React.Fragment>
        <label style={{marginRight: '1rem', marginLeft: '1rem'}}>{formatMessage({id: 'to'})}</label>
        <SADatePicker value={to} onChange={onToChange} disabledDate={disabledTo} error={error.to}/>
      </React.Fragment>
  );

  render() {
    const {intl: {formatMessage}, className, from, to, onFromChange, onToChange, disabledFrom, disabledTo, error = {}} = this.props;

    return (
      <div className={className}>
        <label>{formatMessage({id: 'from'})}</label>
        <SADatePicker value={from} onChange={onFromChange} disabledDate={disabledFrom} error={error.from}/>
        {to && this.renderTo(to, onToChange, disabledTo, error, formatMessage)}
      </div>
    )
  }
}

export default injectIntl(FromToDates);
